<template>
  <div class="PlanejamentoContratoForm_Rodape">
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12" md="5" class="pt-0 pl-0">
          <v-stepper v-model="stepForm">
            <v-stepper-header>
              <div v-for="(passo, index) in sequenciaPassos"
                :key="index"
                :style="{'width': `${100/sequenciaPassos.length}%`}"
                class="PlanejamentoContratoForm_Rodape__Passo">
                <v-stepper-step
                  :complete="stepForm > (index + 1)"
                  :step="(index+1)">
                  {{passo}}
                </v-stepper-step>
                <v-divider
                  v-if="index < sequenciaPassos.length - 1"/>
              </div>
            </v-stepper-header>
          </v-stepper>
        </v-col>

        <planejamento-contrato-form-fluxo-aprovacao
          ref="componenteFluxo"
          :ultimo-passo="ultimoPasso"
          :permite-salvar="permiteSalvar"
          :contrato-edicao="contratoEdicao"
          :contrato-salvar="salvarComAvisoForcaVendas"
          :contrato-formatar="formataContratoParaEnvio"
          :contrato-validar="validaAntesDeSalvarOuFinalizar"
          :edicao="edicao"
          @PlanejamentoContratoFormFluxoAprovacao__podeSolicitarAprovacaoContrato
              ="emitirPodeSolicitarAprovacaoContrato"
          @PlanejamentoContratoFormFluxoAprovacao__temFluxoContrato="emitirTemFluxoContrato">
          <v-btn slot="acoes-padrao" @click="cancelar()" class="mr-3">
            {{ labelCancelar }}
          </v-btn>
          <v-btn slot="acoes-padrao" @click="anterior()"
            class="mr-3"
            dark
            color="accent"
            v-show="exibeAnterior">
            {{ $t('label.anterior') }}
          </v-btn>
          <v-btn slot="acoes-padrao" @click="recalcular()"
            class="mr-3"
            dark
            color="accent"
            v-show="exibeRecalcular"
            :disabled="!permiteSalvar">
            {{ $t('label.recalcular') }}
          </v-btn>
          <v-btn slot="acoes-padrao" @click="proximo()"
            class="mr-3"
            dark
            color="primary"
            v-show="exibeProximo">
            {{ $tc('label.proximo', 1) }}
          </v-btn>
          <v-btn slot="acoes-padrao" @click="salvarRecarregar()"
            class="mr-3"
            dark
            color="primary"
            v-show="exibeSalvar"
            :disabled="!permiteSalvar">
            {{ $t('label.salvar') }}
          </v-btn>
        </planejamento-contrato-form-fluxo-aprovacao>
      </v-row>
    </v-container>

    <confirm
      ref="confirmDialog"
      :persistent="true">
    </confirm>
    <confirm
      ref="avisoForcaVendasDialog"
      :persistent="true"
      max-width="520"
      :agree-label="$t('label.estou_ciente')"
      :disagree-label="$t('label.voltar')">
    </confirm>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import PlanejamentoContratoFormFluxoAprovacao from './PlanejamentoContratoFormFluxoAprovacao';
import Confirm from '../../../shared-components/vuetify/dialog/Confirm';

export default {
  props: {

    definicaoPassos: Object,

    alterarFinalizado: Boolean,
    copia: Boolean,
    novo: Boolean,
    edicao: Boolean,
    somenteLeitura: Boolean,
    contratoEdicao: Object,

    getComponentesPassos: Function,
    validaComponentePasso: Function,
  },
  components: {
    PlanejamentoContratoFormFluxoAprovacao,
    Confirm,
  },
  data() {
    return {
      planejamentoContratoResource: this.$api.planejamentoContratoCadastro(this.$resource),
      workflowContratoResource: this.$api.workflowContrato(this.$resource),
      stepForm: 1,
      avancaPasso: () => {},
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    exibeSalvar() {
      if (this.somenteLeitura) {
        return false;
      }
      return this.ultimoPasso;
    },
    permiteSalvar() {
      return (
        !this.contratoEdicao.status
        || this.contratoEdicao.status === 'EM_CADASTRO'
      );
    },
    ultimoPasso() {
      const ultimoPasso = Object.keys(this.sequenciaPassos).length;
      return this.stepForm === ultimoPasso;
    },
    exibeAnterior() {
      return this.stepForm !== 1;
    },
    exibeProximo() {
      return !this.ultimoPasso;
    },
    passoAtualEhAcoes() {
      const chaves = Object.keys(this.passosHabilitados)
        .filter((chave) => this.passosHabilitados[chave].habilitado);
      return chaves[this.stepForm - 1] === 'acoes';
    },
    exibeRecalcular() {
      if (this.somenteLeitura || this.ultimoPasso) {
        return false;
      }
      return this.passoAtualEhAcoes;
    },
    labelCancelar() {
      return this.passoAtualEhAcoes
        ? this.$t('label.voltar_tela_anterior')
        : this.$t('label.cancelar');
    },
    sequenciaPassos() {
      return Object.values(this.passosHabilitados)
        .filter((passo) => passo.habilitado)
        .map((passo) => passo.label);
    },
    passosHabilitados() {
      return this.definicaoPassos.passosHabilitados(this, this.contratoEdicao);
    },
  },
  methods: {
    carregaInformacoesFluxo(idContrato) {
      this.$refs.componenteFluxo.carregaInformacoesFluxo(idContrato);
    },
    emitirPodeSolicitarAprovacaoContrato(podeSolicitarAprovacaoContrato) {
      setTimeout(() => {
        this.$emit('PlanejamentoContratoFormRodape__podeSolicitarAprovacaoContrato',
          podeSolicitarAprovacaoContrato);
      }, 3E2);
    },
    emitirTemFluxoContrato(temFluxoContrato) {
      setTimeout(() => {
        this.$emit('PlanejamentoContratoFormRodape__temFluxoContrato', temFluxoContrato);
      }, 3E2);
    },
    validaAntesDeAvancar() {
      return this.validaComponentePasso();
    },
    abreUltimoPasso() {
      this.stepForm = Object.keys(this.sequenciaPassos).length;
      this.notificaNovoPasso();
    },
    proximo() {
      if (!this.validaAntesDeAvancar()) {
        return;
      }
      if (this.passoAtualEhAcoes && this.forcaVendasDesmarcada()) {
        this.confirmarAvisoForcaVendas((ok) => {
          if (ok) {
            this.stepForm += 1;
            this.notificaNovoPasso();
          }
        });
        return;
      }
      this.stepForm += 1;
      this.notificaNovoPasso();
    },
    forcaVendasDesmarcada() {
      try {
        const { acoes } = this.getComponentesPassos();
        if (!acoes || typeof acoes.getObjetoFormatado !== 'function') {
          return false;
        }
        const objeto = acoes.getObjetoFormatado();
        return objeto && objeto.pgtoForcaVendas === false;
      } catch (e) {
        return false;
      }
    },
    confirmarAvisoForcaVendas(callback) {
      this.$refs.avisoForcaVendasDialog.openWithParams(
        this.$t('title.aviso_configuracao'),
        this.$t('message.aviso_forca_vendas'),
        callback,
      );
    },
    // No FluxoAprovacao, solicitar aprovação chama contratoSalvar(true);
    // finalizar chama contratoSalvar(false). Só o true mostra o aviso.
    salvarComAvisoForcaVendas(finalizacao) {
      if (finalizacao && this.forcaVendasDesmarcada()) {
        return new Promise((resolve, reject) => {
          this.confirmarAvisoForcaVendas((ok) => {
            if (!ok) {
              resolve(null);
              return;
            }
            this.salvar(finalizacao).then(resolve).catch(reject);
          });
        });
      }
      return this.salvar(finalizacao);
    },
    recalcular() {
      if (!this.validaAntesDeAvancar()) {
        return;
      }
      try {
        const { acoes } = this.getComponentesPassos();
        if (acoes && acoes.$refs && acoes.$refs.planoMetas
            && typeof acoes.$refs.planoMetas.recalculaVariaveisMeta === 'function') {
          acoes.$refs.planoMetas.recalculaVariaveisMeta();
        }
      } catch (e) {
        // mantém o fluxo de salvar mesmo se o recálculo local falhar
      }
      this.salvar(false)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    anterior() {
      this.stepForm -= 1;
      this.notificaNovoPasso();
    },
    notificaNovoPasso() {
      this.$emit('PlanejamentoContratoFormRodape__MudaPasso', this.stepForm);
    },
    cancelar() {
      if (this.somenteLeitura) {
        this.$router.push({
          name: this.$route.params.from || 'planejamento-contrato',
        });
        return;
      }

      this.$refs.confirmDialog
        .openWithParams(
          this.$t('title.atencao'),
          this.$t('message.deseja_cancelar_edicao'),
          (ok) => {
            if (ok) {
              this.$router.push({
                name: this.$route.params.from || 'planejamento-contrato',
              });
            }
          },
        );
    },
    validaAntesDeSalvarOuFinalizar(finalizacao) {
      if (!this.validaComponentePasso()) {
        return Promise.resolve(false);
      }

      const componentes = Object.values(this.getComponentesPassos())
        .filter((c) => c.validacaoAssincrona);

      if (componentes.length === 0) {
        return Promise.resolve(true);
      }

      return Promise.all(
        componentes.map((c) => c.validacaoAssincrona(finalizacao)),
      ).then((arrValidacao) => Promise.resolve(arrValidacao.reduce((a, b) => a && b)));
    },
    formataContratoParaEnvio() {
      const { geral, acoes } = this.getComponentesPassos();

      const passoGeral = geral.getObjetoFormatado();
      const passoComportamento = acoes.getObjetoFormatado();

      return {
        id: this.contratoEdicao.id,
        passoGeral,
        passoComportamento,
      };
    },
    salvarRecarregar() {
      this.salvar().then((idContrato) => {
        if (idContrato !== null) {
          this.alternaRota(idContrato);
        }
      })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    salvar(finalizacao = false) {
      return this.validaAntesDeSalvarOuFinalizar(finalizacao).then((sucesso) => {
        if (!sucesso) {
          return null;
        }
        const contrato = this.formataContratoParaEnvio();
        if (!this.edicao) {
          return this.salvarNovo(contrato, finalizacao);
        }
        return this.atualizar(contrato, finalizacao);
      });
    },
    salvarNovo(contrato, finalizacao) {
      return this.planejamentoContratoResource.salvar(contrato)
        .then((res) => {
          if (!finalizacao) {
            this.$toast(this.$t('message.adicionado_confira_tabela'));
          }
          const idContrato = res.data;
          return idContrato;
        });
    },
    atualizar(contrato, finalizacao) {
      return this.planejamentoContratoResource.atualizar(contrato)
        .then((res) => {
          if (!finalizacao) {
            this.$toast(this.$t('message.adicionado_confira_tabela'));
          }
          const idContrato = res.data;
          return idContrato;
        });
    },
    alternaRota(idContrato) {
      const routeEdicao = 'editarContrato';

      let { name } = this.$router.currentRoute;
      name = name === routeEdicao
        ? name.concat('_') : routeEdicao;

      this.$router.replace({
        name,
        params: { idContrato, passoFinal: true },
      });
    },
    exibeFinalizar() {
      if (this.contratoEdicao.id && this.ultimoPasso && !this.somenteLeitura) {
        const { passoGeral } = this.contratoEdicao;
        if (passoGeral.status !== 'APROVADO') {
          const idContrato = this.contratoEdicao.id;
          return this.workflowContratoResource.existeFluxoCadastrado({ idContrato })
            .then((res) => {
              const existeFluxo = res.data;
              return !existeFluxo;
            });
        }
        return false;
      }
      return false;
    },
    finalizar() {
      return this.validaAntesDeSalvarOuFinalizar(true).then((sucesso) => {
        if (!sucesso) {
          return;
        }
        this.$refs.confirmDialog
          .openWithParams(
            this.$t('title.atencao'),
            this.$t('message.deseja_finalizar_contrato'),
            (ok) => {
              if (ok) {
                const contrato = this.formataContratoParaEnvio();
                this.planejamentoContratoResource.finalizar(contrato)
                  .then(() => {
                    this.$router.push({ name: 'planejamento-contrato' });
                    this.$toast(this.$t('message.contrato_finalizado'));
                  })
                  .catch((err) => {
                    this.$error(this, err);
                  });
              }
            },
          );
      });
    },
  },
  mounted() {
    const { passoFinal, carregaPassoAcoes } = this.$route.params;
    if (passoFinal === true || carregaPassoAcoes === true) {
      setTimeout(() => this.abreUltimoPasso());
    }
  },
};
</script>
<style>
  .PlanejamentoContratoForm_Rodape {
    height: 56px;
    background-color: #EEEEEE;
    display: flex;

    position: fixed;
    z-index: 4;
    transform: translate(0);
    transition: all .4s cubic-bezier(.25,.8,.5,1);
    bottom: 0px;
    left: 0;
    width: 100%;
  }
  .PlanejamentoContratoForm_Rodape .v-stepper {
    background: none;
    border: none;
    box-shadow: none;
  }
  .PlanejamentoContratoForm_Rodape .v-stepper__header,
  .PlanejamentoContratoForm_Rodape .v-stepper__step {
    height: 56px;
  }
  .PlanejamentoContratoForm_Rodape__Passo {
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
</style>
